import { render, staticRenderFns } from "./JoinCip.vue?vue&type=template&id=71caf734&"
import script from "./JoinCip.vue?vue&type=script&lang=js&"
export * from "./JoinCip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports